export default (action, error, errorMessage, userData) => {
    const errorDetails = {
        name: error?.name,
        message: error?.message,
        stack: error?.stack,
        constructor: error?.constructor.name
    };

    for (let prop in error) {
        if (error.hasOwnProperty(prop)) {
            errorDetails[prop] = error[prop];
        }
    }

    const seen = new WeakSet();
    let errorDetailsJsonString = JSON.stringify(errorDetails, (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return '[Circular]';
            }
            seen.add(value);
        }
        return value;
    }, 2);

    let form_data = new FormData;
    form_data.append('action', 'gs_log_singup_login_error');
    form_data.append('error_action', action);
    form_data.append('error_message', errorMessage);
    form_data.append('user_data', JSON.stringify(userData ? userData : {}));
    form_data.append('error', errorDetailsJsonString);
    axios.post(ajax_var.url, form_data);
}
